import { styled, theme, utils } from 'ui/theme';

export const ProductList = styled('div')`
  display: grid;
  gap: ${theme.space[2]};
  grid-template-columns: repeat(2, minmax(${theme.sizes[23]}, 1fr));
  justify-content: center;

  ${utils.media.min('l')`
    &[data-items-desktop="3"] {
      grid-template-columns: repeat(3, 1fr);
    }

    &[data-items-desktop="4"] {
      grid-template-columns: repeat(4, 1fr);
    }
  `}
`;
